import React from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'
import { MessageBanner } from '@contrast-security-inc/design-system-alerts'
import { css } from '@emotion/css'

export const DiagnosticCollectionDisclaimer = () => {
  const { formatMessage } = useIntl()
  return (
    <MessageBanner
      title={formatMessage({ id: 'detail_servers_disclaimer' })}
      variant="warning"
      message={
        <Text>
          {formatMessage({
            id: 'detail_servers_enableDiagnosticCollection_disclaimer'
          })}
        </Text>
      }
      className={css`
        svg {
          overflow: initial !important;
        }
      `}
      inline
    />
  )
}
